import FalconCardHeader from '@/components/common/FalconCardHeader';
import HelpTooltip from '@/app/common/components/HelpTooltip';
import Flex from '@/components/common/Flex';
import { Button, Card, Col, Row } from 'react-bootstrap';
import { crawlTooltip } from '@/app/Crawl/tooltip/crawlTooltips';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import TextLoading from '@/app/common/components/skeleton/TextLoading';
import { getColor } from '@/helpers/utils';
import { Fragment } from 'react';
import type { CSSProperties } from 'react';

type AgGridSkeletonSettings = {
  pagination?: boolean;
  fullscreen?: boolean;
  changeHeight?: boolean;
  saveGrid?: boolean;
  resetGrid?: boolean;
  sideBar?: boolean;
  masterDetail?: unknown;
  exportBtn?: boolean;
};

type AgGridSkeletonProps = {
  height?: CSSProperties['height'];
  settings?: AgGridSkeletonSettings;
};

const AgGridSkeleton = ({
  height = '500px',
  settings = {}
}: AgGridSkeletonProps) => {
  return (
    <>
      <>
        {!settings.exportBtn &&
        !settings.fullscreen &&
        !settings.changeHeight &&
        !settings.saveGrid &&
        !settings.resetGrid ? (
          ''
        ) : (
          <Row>
            <Col xs="auto"></Col>
            <Col>
              <Flex className="mb-3 gap-2" justifyContent="end">
                {settings.fullscreen && (
                  <Button
                    title="تمام صفحه"
                    style={{ width: '30px', height: '30px' }}
                    variant="outline-secondary"
                    className="p-1 d-flex align-items-center justify-content-center"
                  >
                    <FontAwesomeIcon
                      className="fs--1"
                      icon="expand-arrows-alt"
                    />
                  </Button>
                )}
                {settings.changeHeight && (
                  <Button
                    style={{ width: '30px', height: '30px' }}
                    title="تغییر ارتفاع"
                    variant="outline-secondary"
                    size="sm"
                    className="d-flex align-items-center justify-content-center"
                  >
                    <FontAwesomeIcon icon="arrows-alt-v" className="fs--1" />
                  </Button>
                )}
                {settings.saveGrid && (
                  <Button
                    className="p-1 fs--1 gap-2 d-flex align-items-center justify-content-center px-2"
                    variant="falcon-primary"
                  >
                    <FontAwesomeIcon icon="save" />
                    <span>
                      <span className="d-md-inline d-none">ذخیره جدول</span>
                      <span onClick={e => e.stopPropagation()}>
                        <HelpTooltip
                          color={getColor('black')}
                          html={
                            <div className="text-start">
                              {crawlTooltip.saveTable}
                            </div>
                          }
                        />
                      </span>
                    </span>
                  </Button>
                )}
                {settings.resetGrid && (
                  <Button
                    className="p-1 fs--1 gap-2 d-flex align-items-center justify-content-center px-2"
                    variant="outline-secondary"
                  >
                    <FontAwesomeIcon icon="undo-alt" />
                    <span>
                      <span className="d-md-inline d-none">ریست</span>
                      <span onClick={e => e.stopPropagation()}>
                        <HelpTooltip html={crawlTooltip.resetTable} />
                      </span>
                    </span>
                  </Button>
                )}
              </Flex>
            </Col>
          </Row>
        )}
      </>
      <Card className="h-100">
        <FalconCardHeader
          title={
            <div>
              درحال بارگذاری
              <HelpTooltip html="درحال بارگذاری" />
            </div>
          }
          titleTag="h6"
          className="py-2"
          light
        />
        <Card.Body
          as={Flex}
          direction="column"
          justifyContent="between"
          className="py-2"
        >
          <div
            style={{ height }}
            className="d-flex flex-column justify-content-around  overflow-auto"
          >
            {Array.from({ length: 20 }).map((_, index) => (
              <div
                key={index}
                className="w-100 p-3 d-flex gap-4 align-items-center"
                style={{
                  height: 40,
                  backgroundColor:
                    index % 2 === 0
                      ? 'var(--falcon-gray-100)'
                      : 'var(--falcon-emphasis-bg) !important'
                }}
              >
                <TextLoading />
                <div style={{ width: 100 }} />
                {Array.from({ length: 4 }).map((_, index) => (
                  <Fragment key={index}>
                    <TextLoading />
                    <TextLoading />
                  </Fragment>
                ))}
              </div>
            ))}
          </div>
        </Card.Body>
      </Card>
    </>
  );
};

export default AgGridSkeleton;
